function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "crown",
  transform: "translate(-122.183 -123.595)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_23",
  "data-name": "Group 23",
  transform: "translate(122.183 123.595)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_21",
  "data-name": "Group 21",
  transform: "translate(2.526 17.676)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_18",
  "data-name": "Group 18"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_17",
  "data-name": "Group 17"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_88",
  "data-name": "Path 88",
  d: "M164.462,348.425h-8.1a1.164,1.164,0,1,1,0-2.324h8.1a1.164,1.164,0,1,1,0,2.324Z",
  transform: "translate(-155.123 -346.101)",
  fill: "#fed12f"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_20",
  "data-name": "Group 20",
  transform: "translate(11.523)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_19",
  "data-name": "Group 19"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_89",
  "data-name": "Path 89",
  d: "M299.773,348.425h-1.325a1.162,1.162,0,0,1,0-2.324h1.325a1.162,1.162,0,1,1,0,2.324Z",
  transform: "translate(-297.286 -346.101)",
  fill: "#fed12f"
})))), /*#__PURE__*/React.createElement("g", {
  id: "Group_22",
  "data-name": "Group 22",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_90",
  "data-name": "Path 90",
  d: "M138.345,139.737H126.307a1.562,1.562,0,0,1-1.5-1.124l-2.535-8.449a2.018,2.018,0,0,1,.554-2.065,1.981,1.981,0,0,1,2.084-.407l2.4.928,3.415-4.271a2,2,0,0,1,3.124,0l3.415,4.272,2.416-.933a1.983,1.983,0,0,1,2.079.4,2.019,2.019,0,0,1,.563,2.056l-2.472,8.458A1.58,1.58,0,0,1,138.345,139.737Zm-11.23-1.827h0Z",
  transform: "translate(-122.183 -123.595)",
  fill: "#fed12f"
}))));

var SvgCrown = function SvgCrown(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20.223,
    height: 20,
    viewBox: "0 0 20.223 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCrown, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/crown.773c6626.svg";
export { ForwardRef as ReactComponent };